import './bigkahuna/style';
import FormStructure from './bigkahuna/form_structure';

export default FormStructure;